import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { Component, inject, OnInit } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { AlertsService } from '../../../../services/alerts.service';
import { UserService } from '../../../../services/user.service';
import { AsyncPipe } from '@angular/common';
import { HasPermissionDirective } from '../../../../security/has-permission.directive';
import { USER_PERMISSIONS } from '../../../../constants/permissions';
import { AlertsMenu } from '../../../common/alerts-menu/alerts-menu';

/** Navigation sidebar for the counselor view. Fetches and exposes the current user for display. */
@Component({
  selector: 'app-counselor-nav',
  imports: [
    MatIconModule,
    MatListModule,
    MatBadgeModule,
    MatMenuModule,
    CdkOverlayOrigin,
    RouterModule,
    AsyncPipe,
    HasPermissionDirective,
    AlertsMenu,
  ],
  templateUrl: './counselor-nav.html',
  styleUrl: './counselor-nav.css',
})
export class CounselorNav implements OnInit {
  /** Tracks the currently active nav item for highlight state in the template. */
  activeElement = 'dashboard';

  /** Permission constants exposed to the template. */
  permissions = USER_PERMISSIONS;

  /** Service for fetching the current authenticated user. */
  private userService = inject(UserService);

  /** Bound in the template for the alerts badge count. */
  alertsService = inject(AlertsService);

  /** Observable of the current user, bound directly in the template via async pipe. */
  user$ = this.userService.getCurrentUser();

  ngOnInit(): void {}

  /**
   * Logs the user out via the server's session-ending /logout route.
   * @returns {void}
   */
  logout(): void {
    window.location.href = '/logout';
  }
}
